import { CircularProgress } from '@material-ui/core';
import Lesson from 'models/Lesson';
import React, { useEffect, useState } from 'react';
import { getAllLessons } from 'services/LessonService';
import LessonContext from './context';
import styles from './LessonsProvider.module.css';

const LessonsProvider: React.FC = ({ children }) => {
  const [refreshData, setRefreshData] = useState(true);
  const [lessons, setLessons] = useState<Lesson[] | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      if (!refreshData) {
        return;
      }

      // TODO once this returns unapproved lessons too, we'll want to filter them out here for non-admin users
      const serverData = await getAllLessons();
      let lessons: Lesson[];

      // The database is an object where each lessonId is the key, and the remaining lesson properties
      // are in an object assigned to that key. We need the lessonId to be part of our Lesson object
      // in the UI, so we use Object.entries to create an array of distinct [key, value] arrays and
      // then use map to build the lessons themselves
      const lessonEntries = Object.entries(serverData);
      lessons = lessonEntries.map((entry) => {
        const lessonId = entry[0];
        const otherProperties = entry[1];

        return { ...otherProperties, lessonId };
      });

      if (lessons) {
        // Sort lessons alphabetically
        lessons.sort((a, b) =>
          a.lessonTitle.toLowerCase().localeCompare(b.lessonTitle.toLowerCase()),
        );
        setLessons(lessons);
      } else {
        setLessons([]);
      }
      setRefreshData(false);
    }

    getData();
  }, [refreshData]);

  return (
    <LessonContext.Provider value={{ lessons, setRefreshData }}>
      {lessons === undefined ? (
        <div className={styles.loadingContainer}>
          <CircularProgress />
        </div>
      ) : (
        children
      )}
    </LessonContext.Provider>
  );
};

export default LessonsProvider;
